import { useState, useCallback, useEffect, lazy, Suspense } from 'react'
import './App.css'
import Header from './components/Header'
import Sidebar from './components/Sidebar'
import Home from './pages/Home'
import EnrichAndBid from './pages/EnrichAndBid'
import LifetimeValue from './pages/LifetimeValue'
import MetricsDeepdive from './pages/MetricsDeepdive'
import MetricsPerformance from './pages/MetricsPerformance'
import CustomerBehavior from './pages/CustomerBehavior'
import ProductPerformance from './pages/ProductPerformance'
import FeedEnrichment from './pages/ProductCataloging'
import ProductCRO from './pages/ProductCRO'
import AdsCopyOptimization from './pages/AdsCopyOptimization'
import RepurchaseRate from './pages/RepurchaseRate'
import SegmentBestseller from './pages/SegmentBestseller'
import ProductAudit from './pages/ProductAudit'
import MetaAdsShopping from './pages/MetaAdsShopping'
import MetaCreativeGeneration from './pages/MetaCreativeGeneration'
import MetaCreativeAnalysis from './pages/CreativeAnalysis'
import CreativeAnalysisSetting from './pages/CreativeAnalysisSetting'
import Reports from './pages/Reports'
import Groups from './pages/Groups'
import ReportTopPerforming from './pages/ReportTopPerforming'
import ReportComparativeAnalysis from './pages/ReportComparativeAnalysis'
import LandingPageOptimization from './pages/LandingPageOptimization'
import LandingPageOptimizationV2 from './pages/v2/LandingPageOptimization'
import ChatBotUI from './pages/ChatBotUI'
import ChatBotSuggestionGen from './pages/ChatBotSuggGen'
import GoogleAdsCopySS from './pages/GoogleAdsCopySS'
import ExistingDivs from './pages/ExistingDivs'
import EnhanceSections from './pages/EnhanceSections'
import NewSections from './pages/NewSections'
import Forms from './pages/Forms'
import SavedSections from './pages/SavedSections'
import LandingPagePreview from './pages/LandingPagePreview'
import SignOut from './pages/SignOut'
import Login from './pages/login';
import ShareAcceptPage, { ShareGate, CanvasShareGate, ShareReturn } from './pages/ShareAcceptPage';
import CanvasSharePage from './pages/CanvasSharePage';
import Signup from './pages/signup';
import StoreSetup from './pages/StoreSetup';
import VisualEditor from './pages/VisualEditor';
import LocationPersonalization from './pages/LocationPersonalization';
import MetaAdsPersonalization from './pages/MetaAdsPersonalization';
import Setup from './pages/Setup';
import CustomCampaignPersonalization from './pages/CustomCampaignPersonalization';
import CustomCampaignPersonalizationV2 from './pages/v2/CustomCampaignPersonalization';
import Settings from './pages/Settings';
import { Route, Routes, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { QueueProvider } from './context/QueueContext';
import SectionQueue from './components/SectionQueue';
import Cookies from 'js-cookie';
import { identify } from './utils/analytics';
import SavingCalculator from './pages/SavingCalculator';
import CampaignSummary from './pages/CampaignSummary';
import Category from './pages/Category';
import PersonalizationCampaign from './pages/PersonalizationCampaign';
import AIModeLpCustomization from './pages/AIModeLpCustomization';
import AIResponseEditor from './pages/AIResponseEditor';
import AIResponseEditorV2 from './pages/v2/AIResponseEditor';
import CreateExpGB from './pages/CreateExpGB';
import AdminDashboard from './pages/AdminDashboard';
import DevDashboard from './pages/DevDashboard';
import AccountAccessPage from './pages/AccountAccessPage';
import BlockRepository from './pages/BlockRepository';
import BusinessContextAndAssets from './pages/BusinessContextAndAssets';
import AIAssetContentGenerator from './pages/AIAssetContentGenerator'
import DynamicTemplateTest from './pages/DynamicTemplateTest';
import UserAccountsPage from './pages/UserAccountsPage';
import AssetsSection from './pages/AssetsSection';
import AnalyticsDashboard from './pages/AnalyticsDashboard';
import KeywordLPRelevance from './pages/KeywordLPRelevance';
import BulkVariationUpload from './pages/BulkVariationUpload';
import Opportunities from './pages/Opportunities';
import Pricing from './pages/Pricing';
import SubscriptionManagement from './pages/SubscriptionManagement';
import AdminSubscriptionDashboard from './pages/AdminSubscriptionDashboard';
import PricingPlanManagement from './pages/PricingPlanManagement';
import AdminBillingReport from './pages/AdminBillingReport';
import MCPConnectorsPage from './mcp-connectors/MCPConnectorsPage';
import AccountSetup from './pages/AccountSetup';
import SetupBanner from './components/SetupBanner';
import SupportWidget from './components/SupportWidget';
import OAuthDone from './pages/OAuthDone';

// Lazy: the Cognitive Flows feature (all pages, tables, editor) is its own chunk
// so the main app bundle doesn't pay for it until the feature is opened.
const CognitiveFlowsLayout = lazy(() => import('./cognitive-flows/CognitiveFlowsLayout'));

function App() {

  const [shop_domain, setShopDomain] = useState(Cookies.get('shop'));
  const [shop_name, setShopName] = useState(Cookies.get('shop_name'));
  const stores = (Cookies.get('stores')) ? JSON.parse(Cookies.get('stores')) : [];
  const allowed_pages_json = (Cookies.get('allowed_pages_json')) ? JSON.parse(Cookies.get('allowed_pages_json')) : {};
  const show_under_dev_pages = Cookies.get('show_under_dev_pages');
  const user_email = Cookies.get('user_email');
  const needs_store_setup = Cookies.get('needs_store_setup') === 'true';
  const user_role = Cookies.get('user_role');
  const user_permissions = (Cookies.get('user_permissions')) ? JSON.parse(Cookies.get('user_permissions')) : [];
  // const app_url = "https://insights.digital-mozarts.com";
  let app_url = "http://localhost:9000";
  if(process.env.REACT_APP_BASE_URL !== null && process.env.REACT_APP_BASE_URL !== undefined){
    app_url = process.env.REACT_APP_BASE_URL;
  }


  const [openSidebarToggle, setOpenSidebarToggle] = useState(false)

  // PostHog person profiles are 'identified_only', so nothing is attributable
  // to a user until identify() runs. Cookies are the auth source of truth and a
  // full reload always follows login, so this effect fires with them populated;
  // it must stay ABOVE the early returns below (rules of hooks) and re-fires
  // when the user switches store. identify() is idempotent — StrictMode's
  // double-invoke and repeat renders are harmless.
  useEffect(() => {
    if (!user_email) return;
    identify(user_email, {
      shop: shop_domain || null,
      shop_name: shop_name || null,
      role: user_role || null,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user_email, shop_domain, shop_name, user_role]);

  var temp_selected_page = 0;
  if(sessionStorage.getItem("page_info")){
    temp_selected_page = Number(sessionStorage.getItem("page_info"));
  }

  const [selectedPage, setSelectedPage] = useState(temp_selected_page)
  const OpenSidebar = () => {
    setOpenSidebarToggle(!openSidebarToggle)
  }

  const ViewedPage = useCallback((value) => {
    setTimeout(() => {
      sessionStorage.setItem("page_info", value);
      setSelectedPage(value);
    }, 100);
  }, []);

  const changeStoreDomain = (value) => {
    setShopDomain(value)
  }

  const changeStoreName = (value) => {
    setShopName(value)
  }

  const location = useLocation();
  const queryParameters = new URLSearchParams(window.location.search)

  // OAuth popup detection via localStorage (window.opener and window.name are both
  // unreliable: COOP severs opener, Chrome clears window.name on cross-origin nav).
  // The parent sets 'scalex_oauth_pending' before opening the popup.
  // sessionStorage 'scalex_is_main' is only present in the parent window (per-window storage).
  if (
    localStorage.getItem('scalex_oauth_pending') === 'pending' &&
    !sessionStorage.getItem('scalex_is_main')
  ) {
    localStorage.setItem('scalex_oauth_pending', 'done');
    localStorage.setItem('scalex_auth_changed', Date.now().toString());
    window.close();
    return <OAuthDone inPopup={true} />;
  }

  // Verified user with no store yet — complete onboarding before main app (cookies lack shop/stores)
  if (user_email && needs_store_setup) {
    return (
      <>
        <Toaster containerStyle={{ zIndex: 999999999 }} />
        <Routes>
          <Route path="/setup-store" element={<StoreSetup app_url={app_url} />} />
          <Route path="/signup" element={<Signup app_url={app_url} />} />
          <Route path="/login" element={<Login app_url={app_url} />} />
          <Route path="/share/:token" element={<ShareAcceptPage app_url={app_url} />} />
          <Route path="/canvas-share/:token" element={<CanvasSharePage app_url={app_url} />} />
          <Route path="*" element={<Navigate to="/setup-store" replace />} />
        </Routes>
      </>
    );
  }

  if((!shop_domain) || (!stores) || (Object.keys(stores).length === 0) || (!allowed_pages_json) || (Object.keys(allowed_pages_json).length === 0)) {
    return (
      <>
        <Toaster containerStyle={{ zIndex: 999999999 }} />
        <Routes>
          <Route path="/signup" element={<Signup app_url={app_url} />} />
          <Route path="/login" element={<Login app_url={app_url} />} />
          <Route path="/share/:token" element={<ShareGate app_url={app_url} />} />
          <Route path="/canvas-share/:token" element={<CanvasShareGate app_url={app_url} />} />
          <Route path="*" element={<Login app_url={app_url} />} />
        </Routes>
      </>
    );
  }

  // A shared canvas renders STANDALONE, never inside the signed-in shell:
  // wrapping it in this account's sidebar/header would present another
  // client's data under this client's navigation. The needs-store-setup and
  // no-stores branches above already render it outside the grid.
  if (location.pathname.startsWith('/canvas-share/')) {
    return (
      <>
        <Toaster containerStyle={{ zIndex: 999999999 }} />
        <Routes>
          <Route path="/canvas-share/:token" element={<CanvasSharePage app_url={app_url} />} />
        </Routes>
      </>
    );
  }

  return (
    <div className='grid-container'>
      <QueueProvider>
      <Header OpenSidebar={OpenSidebar} shop_domain={shop_domain}/>
      <Sidebar app_url={app_url} ViewedPage={ViewedPage} openSidebarToggle={openSidebarToggle} OpenSidebar={OpenSidebar} selectedPage={selectedPage} stores={stores} changeStoreDomain={changeStoreDomain} changeStoreName={changeStoreName} shop_domain={shop_domain} ShopName={shop_name} allowed_pages_json={allowed_pages_json} show_under_dev_pages={show_under_dev_pages} />
      <Toaster containerStyle={{ zIndex: 999999999 }}/>
      <SectionQueue />
      <SetupBanner app_url={app_url} />
      {/* Floating Support entry — every signed-in page. The login/OAuth/
          canvas-share early returns above deliberately exclude it: the Help
          endpoint needs a session, and shared views must stay chrome-free. */}
      <SupportWidget app_url={app_url} />
      <ShareReturn />
      <Routes>
        <Route path="/share/:token" element={<ShareAcceptPage app_url={app_url} />}></Route>
        <Route path="/metrics-performance" element={<MetricsPerformance ViewedPage={ViewedPage} shop_domain={shop_domain} app_url={app_url}/>}></Route>
        <Route path="/metrics-deepdive" element={<MetricsDeepdive ViewedPage={ViewedPage} shop_domain={shop_domain} app_url={app_url}/>}></Route>
        <Route path="/lifetime-value" element={<LifetimeValue ViewedPage={ViewedPage} shop_domain={shop_domain} app_url={app_url}/>}></Route>
        <Route path="/repurchase-rate" element={<RepurchaseRate ViewedPage={ViewedPage} shop_domain={shop_domain} app_url={app_url}/>}></Route>
        <Route path="/product-journey" element={<CustomerBehavior ViewedPage={ViewedPage} shop_domain={shop_domain} app_url={app_url}/>}></Route>
        <Route path="/product-performance" element={<ProductPerformance ViewedPage={ViewedPage} shop_domain={shop_domain} app_url={app_url}/>}></Route>
        <Route path="/feed-enrichment" element={<FeedEnrichment ViewedPage={ViewedPage} shop_domain={shop_domain} app_url={app_url}/>}></Route>
        <Route path="/product-cro" element={<ProductCRO ViewedPage={ViewedPage} shop_domain={shop_domain} app_url={app_url}/>}></Route>
        <Route path="/ads-copy-optimization" element={<AdsCopyOptimization ViewedPage={ViewedPage} shop_domain={shop_domain} app_url={app_url}/>}></Route>
        <Route path="/segment-bestseller" element={<SegmentBestseller ViewedPage={ViewedPage} shop_domain={shop_domain} app_url={app_url}/>}></Route>
        <Route path="/all-product-audit" element={<ProductAudit ViewedPage={ViewedPage} shop_domain={shop_domain} app_url={app_url}/>}></Route>
        <Route path="/shopping" element={<MetaAdsShopping ViewedPage={ViewedPage} shop_domain={shop_domain} app_url={app_url}/>}></Route>
        <Route path="/creative_ideation" element={<MetaCreativeGeneration ViewedPage={ViewedPage} shop_domain={shop_domain} app_url={app_url}/>}></Route>
        <Route path="/creative-analysis" element={<MetaCreativeAnalysis ViewedPage={ViewedPage} shop_domain={shop_domain} app_url={app_url}/>}></Route>
        { process.env.REACT_APP_VERSION === 'v2' ?
          <Route path="/landing-page-optimization" element={<LandingPageOptimizationV2 ViewedPage={ViewedPage} shop_domain={shop_domain} app_url={app_url}/>}></Route>
          :
          <Route path="/landing-page-optimization" element={<LandingPageOptimization ViewedPage={ViewedPage} shop_domain={shop_domain} app_url={app_url}/>}></Route>
        }
        <Route path="/chatbot" element={<ChatBotUI ViewedPage={ViewedPage} shop_domain={shop_domain} app_url={app_url}/>}></Route>
        <Route path="/chatbot-suggestions-generation" element={<ChatBotSuggestionGen ViewedPage={ViewedPage} shop_domain={shop_domain} app_url={app_url}/>}></Route>
        <Route path="/imported-sections" element={<ExistingDivs ViewedPage={ViewedPage} shop_domain={shop_domain} app_url={app_url}/>}></Route>
        <Route path="/enhance-sections" element={<EnhanceSections ViewedPage={ViewedPage} shop_domain={shop_domain} app_url={app_url}/>}></Route>
        <Route path="/new-sections" element={<NewSections ViewedPage={ViewedPage} shop_domain={shop_domain} app_url={app_url}/>}></Route>
        <Route path="/imported-forms" element={<Forms ViewedPage={ViewedPage} shop_domain={shop_domain} app_url={app_url}/>}></Route>
        <Route path="/saved-sections" element={<SavedSections ViewedPage={ViewedPage} shop_domain={shop_domain} app_url={app_url}/>}></Route>
        <Route path="/lp-preview" element={<LandingPagePreview ViewedPage={ViewedPage} shop_domain={shop_domain} app_url={app_url}/>}></Route>
        <Route path="/google-ads-copy-ss" element={<GoogleAdsCopySS ViewedPage={ViewedPage} shop_domain={shop_domain} app_url={app_url}/>}></Route>
        <Route path="/" element={<Home ViewedPage={ViewedPage} shop_domain={shop_domain} app_url={app_url}/>}></Route>
        <Route path="/reports" element={<Reports ViewedPage={ViewedPage} shop_domain={shop_domain} app_url={app_url}/>}></Route>
        <Route path="/groups" element={<Groups ViewedPage={ViewedPage} shop_domain={shop_domain} app_url={app_url}/>}></Route>
        <Route path="/saving-calculator"element={<SavingCalculator ViewedPage={ViewedPage} shop_domain={shop_domain} app_url={app_url} />}/>
        <Route path="/settings" element={<Settings ViewedPage={ViewedPage} shop_domain={shop_domain} app_url={app_url}/>}></Route>
        <Route path="/meta-creative-settings" element={<CreativeAnalysisSetting ViewedPage={ViewedPage} shop_domain={shop_domain} app_url={app_url}/>}></Route>
        <Route path="/sign-out" element={<SignOut ViewedPage={ViewedPage} shop_domain={shop_domain} app_url={app_url}/>}></Route>
        <Route path="/report/top_performing/:report_id" element={<ReportTopPerforming ViewedPage={ViewedPage} shop_domain={shop_domain} app_url={app_url}/>}></Route>
        <Route path="/report/comparative_analysis/:report_id" element={<ReportComparativeAnalysis ViewedPage={ViewedPage} shop_domain={shop_domain} app_url={app_url}/>}></Route>
        <Route path="/enrich-and-bid" element={<EnrichAndBid ViewedPage={ViewedPage} shop_domain={shop_domain} app_url={app_url}/>}></Route>
        <Route path="/editor" element={<VisualEditor shop_domain={shop_domain} app_url={app_url} />} />
        <Route path="/location-personalization" element={<LocationPersonalization ViewedPage={ViewedPage} shop_domain={shop_domain} app_url={app_url} />} />
        <Route path="/campaign-summary" element={<CampaignSummary key={shop_domain} ViewedPage={ViewedPage} shop_domain={shop_domain} app_url={app_url}/>}></Route>
        <Route path="/category" element={<Category ViewedPage={ViewedPage} shop_domain={shop_domain} app_url={app_url}  allowed_pages_json={allowed_pages_json} />}></Route>
        <Route path="/personalization-campaign" element={<PersonalizationCampaign ViewedPage={ViewedPage} shop_domain={shop_domain} app_url={app_url}/>}></Route>
        <Route path="/meta-ads-personalization" element={<MetaAdsPersonalization ViewedPage={ViewedPage} shop_domain={shop_domain} app_url={app_url}/>}></Route>
        <Route path="/setup" element={<Setup ViewedPage={ViewedPage} shop_domain={shop_domain} app_url={app_url}/>}></Route>
        { process.env.REACT_APP_VERSION === 'v2' ?
          <Route path="/custom-campaign-personalization" element={<CustomCampaignPersonalizationV2 ViewedPage={ViewedPage} shop_domain={shop_domain} app_url={app_url}/>}></Route>
          :
          <Route path="/custom-campaign-personalization" element={<CustomCampaignPersonalization ViewedPage={ViewedPage} shop_domain={shop_domain} app_url={app_url}/>}></Route>
        }
        <Route path="/ai-mode-lp-customization" element={<AIModeLpCustomization ViewedPage={ViewedPage} shop_domain={shop_domain} app_url={app_url}/>}></Route>
        { process.env.REACT_APP_VERSION === 'v2' ?
          <Route path="/ai-response-editor" element={<AIResponseEditorV2 ViewedPage={ViewedPage} shop_domain={shop_domain} app_url={app_url}/>}></Route>
          :
          <Route path="/ai-response-editor" element={<AIResponseEditor ViewedPage={ViewedPage} shop_domain={shop_domain} app_url={app_url}/>}></Route>
        }
        <Route path="/create-experiment-gb" element={<CreateExpGB ViewedPage={ViewedPage} shop_domain={shop_domain} app_url={app_url}/>}></Route>
        <Route path="/admin" element={<AdminDashboard ViewedPage={ViewedPage} app_url={app_url} />}></Route>
        <Route path="/dev" element={<DevDashboard ViewedPage={ViewedPage} app_url={app_url} shop_domain={shop_domain} />}></Route>
        <Route path="/business-context-and-assets" element={<BusinessContextAndAssets ViewedPage={ViewedPage} shop_domain={shop_domain} app_url={app_url} />}></Route>
        <Route path="/admin/account-access/:shop" element={<AccountAccessPage ViewedPage={ViewedPage} app_url={app_url} />}></Route>
        <Route path="/admin/user-accounts/:email" element={<UserAccountsPage ViewedPage={ViewedPage} app_url={app_url} />}></Route>
        <Route path="/block-repository" element={<BlockRepository ViewedPage={ViewedPage} shop_domain={shop_domain} app_url={app_url}/>}></Route>
        <Route path="/ai-asset-content-generator" element={<AIAssetContentGenerator ViewedPage={ViewedPage} shop_domain={shop_domain} app_url={app_url}/>}></Route>
        <Route path="/assets-section" element={<AssetsSection ViewedPage={ViewedPage} shop_domain={shop_domain} app_url={app_url}/>}></Route>
        <Route path="/analytics-dashboard" element={<AnalyticsDashboard ViewedPage={ViewedPage} shop_domain={shop_domain} app_url={app_url}/>}></Route>
        <Route path="/dynamic-template-test" element={<DynamicTemplateTest />}></Route>
        <Route path="/keyword-lp-relevance" element={<KeywordLPRelevance ViewedPage={ViewedPage} shop_domain={shop_domain} app_url={app_url}/>}></Route>
        <Route path="/bulk-variation-upload" element={<BulkVariationUpload ViewedPage={ViewedPage} shop_domain={shop_domain} app_url={app_url}/>}></Route>
        <Route path="/opportunities" element={<Opportunities ViewedPage={ViewedPage} shop_domain={shop_domain} app_url={app_url}/>}></Route>
        <Route path="/pricing" element={<Pricing ViewedPage={ViewedPage} app_url={app_url}/>}></Route>
        <Route path="/subscription-management" element={<SubscriptionManagement ViewedPage={ViewedPage} app_url={app_url}/>}></Route>
        <Route path="/admin/subscriptions" element={<AdminSubscriptionDashboard ViewedPage={ViewedPage} app_url={app_url}/>}></Route>
        <Route path="/admin/billing-report" element={<AdminBillingReport ViewedPage={ViewedPage} app_url={app_url}/>}></Route>
        <Route path="/admin/pricing-plans" element={<PricingPlanManagement ViewedPage={ViewedPage} app_url={app_url}/>}></Route>
        <Route path="/cognitive-flows/*" element={
          <Suspense fallback={<div style={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#64748b' }}>Loading Cognitive Flows…</div>}>
            {/* key: a store switch can now land here directly (access-aware
                redirect), and the CF context bootstraps once per mount — the
                same remount-on-store-change contract /campaign-summary uses. */}
            <CognitiveFlowsLayout key={shop_domain} app_url={app_url} shop_domain={shop_domain} ViewedPage={ViewedPage} />
          </Suspense>
        }></Route>
        <Route path="/connectors" element={<MCPConnectorsPage app_url={app_url} shop_domain={shop_domain} ViewedPage={ViewedPage} />}></Route>
        <Route path="/connectors/chat" element={<Navigate to="/cognitive-flows/chat" replace />} />
        <Route path="/account-setup" element={<AccountSetup app_url={app_url} shop_domain={shop_domain} />}></Route>
        <Route path="/oauth-done" element={<OAuthDone />}></Route>
      </Routes>
      </QueueProvider>
    </div>
  )
}
  
export default App